// 投放目标是下单，所以还需要在网页里添加piexl追踪下单事件，并把下单事件传给FB服务器，让FB算法优化广告效果
// https://developers.facebook.com/docs/facebook-pixel/implementation/conversion-tracking/?translation
// https://developers.facebook.com/docs/facebook-pixel/implementation#base-code

import { getQuery } from '@/utils/utils'

const FB_PIXEL_ID = `2975531102715422`

// 只有在toplupe的域名下使用facebook piexl
function isCanLoad() {
  const source = getQuery('source') || ''
  const result = source ? source.startsWith('XMFB') : false
  return result && process.client
}

export function initPiexl() {
  if (isCanLoad()) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = !0
      n.version = '2.0'
      n.queue = []
      t = b.createElement(e)
      t.id = '__fbevents__id'
      t.async = !0
      t.src = v
      s = b.getElementsByTagName(e)[0]
      s.parentNode.insertBefore(t, s)
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js'
    )

    if (fbq) {
      fbq('init', FB_PIXEL_ID)
      fbq('track', 'PageView')
    }

    // eslint-disable-next-line no-inner-declarations
    function setNoScript() {
      const img = document.createElement('img')
      img.setAttribute('width', 1)
      img.setAttribute('height', 1)
      img.style.display = 'none'
      img.setAttribute(
        'src',
        `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`
      )
      const noscript = document.createElement('noscript')
      noscript.appendChild(img)
      document.body.insertBefore(noscript, document.querySelector('#app'))
    }
    setNoScript()
  }
}

export const fb_track = () => {
  if (isCanLoad() && window.fbq) {
    fbq && fbq('trackCustom', 'any_click', { action_source: 'website' })
  }
}

export const fb_track_purchase = ({
  content_ids,
  content_name,
  content_type = 'product',
  contents,
  currency,
  value,
  orderNo,
}) => {
  if (isCanLoad() && window.fbq) {
    fbq &&
      fbq(
        'track',
        'Purchase',
        {
          content_ids,
          content_name,
          content_type,
          contents,
          currency,
          value,
        },
        { eventID: orderNo }
      )
  }
}

export const fb_track_lead = ({ content_name }) => {
  if (isCanLoad() && window.fbq) {
    fbq &&
      fbq('track', 'Lead', {
        content_name,
      })
  }
}
